module.exports = __webpack_public_path__ + "static/media/externalBarn_0.fe5e28f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/barn/externalBarn_0.png
// module id = 1296
// module chunks = 3